module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("gaiVd"))).then(() => parcelRequire('d0iPb'));